<section class="m-section second">
  <div class="container">
    <div class="content">
      <div class="title">
        <h2 class="title-section">¡Tu propuesta ya fue enviada!</h2>
      </div>
      <div class="info">
        <p class="text">Gracias por confiar en nosotros.</p>
        <p class="text">Hemos recibido tu solicitud y en breve recibirás una propuesta
          personalizada en el correo electrónico que proporcionaste.</p>
      </div>
      <div class="button">
        <button class="btn-secondary" routerLink="/" (click)="goTo('nav')">Volver al Inicio</button>
      </div>
      <div class="redes">
        <p class="text">Conecta con nosotros</p>
        <div class="as">
          <a href="javascript:void(0)" target="_blank">
            <img src="/assets/images/icons/face.png" alt="Icono Facebook">
          </a>
          <a href="javascript:void(0)" target="_blank">
            <img src="/assets/images/icons/insta.png" alt="Icono Instagram">
          </a>
          <a href="javascript:void(0)" target="_blank">
            <img src="/assets/images/icons/mail.png" alt="Icono Email">
          </a>
          <a href="javascript:void(0)" target="_blank">
            <img src="/assets/images/icons/whats.png" alt="Icono Whatsapp">
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
